import { createContext } from 'react';
import { Locale } from 'date-fns';
import { frFR as muiFrFR } from '@mui/material/locale';
import { frFR } from '@mui/x-date-pickers-pro/locales';
import { TFunction } from 'i18next';

// ----------------------------------------------------------------------

export type LocaleKey = 'fr';

export type LangConfig = {
  label: string;
  value: LocaleKey;
  systemValue: typeof muiFrFR;
  icon: string;
  dateFns: Locale;
  localeText: typeof frFR.components.MuiLocalizationProvider.defaultProps.localeText;
};

export type Languages = Record<LocaleKey, LangConfig>;

export type LocaleContextType = {
  currentLang: LangConfig;
  languages: Languages;
  onChangeLang: (newLang: LocaleKey) => void;
  translate: TFunction;
};

// ----------------------------------------------------------------------

export const LocaleContext = createContext<LocaleContextType | null>(null);
